import type { ConsentPayload } from '@models/consent';
import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';

/** Checkout exposes 4 consent toggles; quiz non-PHI consent is set at signup only. */
export type CheckoutConsentPayload = Omit<ConsentPayload, 'consentEmailPersonalizedQuiz'>;

export const useConsentForm = createSharedComposable(() => {
  const consentForm = ref<CheckoutConsentPayload>({
    consentEmailGeneralMarketing: false,
    consentEmailPersonalizedHealth: false,
    consentSmsMarketing: false,
    consentSmsTransactional: false,
  });

  return {
    consentForm,
  };
});
